// extracted by mini-css-extract-plugin
module.exports = {"gsapdGroupD":"groupcD_gsapdGroupD__hsTpl"};